import { AlphaNumeric } from './alphaNumeric.directive';
import { OnlyNumber } from './onlyNumber.directive';

export const APP_DIRECTIVES: any[] = [
	AlphaNumeric,
	OnlyNumber
];

export * from './alphaNumeric.directive';
export * from './onlyNumber.directive';


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/common/directive/index.ts